import { Box, BoxProps, Flex, Text } from '@chakra-ui/react';
import { match } from 'ts-pattern';
import { Heading, Paragraph, colors } from 'ui-components';
import {
  colorFemale,
  colorMale,
  colorOther,
} from '~/screens/CreatorAudienceDemographics/GenderDistribution';

type Gender = 'Male' | 'Female' | 'Other';

const getGenderColor = (gender: Gender) => {
  return match(gender)
    .with('Male', () => colorMale)
    .with('Female', () => colorFemale)
    .otherwise(() => colorOther);
};

interface LegendProps extends BoxProps {
  gender: Gender;
  value: number;
  isModal?: boolean;
}

export const Legend = ({
  gender,
  value,
  isModal = false,
  ...props
}: LegendProps) => {
  return (
    <Flex direction="column" gap={!isModal ? 2 : 0}>
      <Flex alignItems="center" gap={2}>
        <Box
          height="12px"
          width="12px"
          borderRadius="2px"
          backgroundColor={getGenderColor(gender)}
          {...props}
        />
        {!isModal ? (
          <Paragraph color={colors.primary[400]} fontWeight="medium">
            {gender}
          </Paragraph>
        ) : (
          <Text fontSize="2xs" color={colors.primary[400]}>
            {gender}
          </Text>
        )}
      </Flex>
      {!isModal ? (
        <Heading size="md">{value}%</Heading>
      ) : (
        <Text fontSize="2xs" fontWeight="medium">
          {value}%
        </Text>
      )}
    </Flex>
  );
};
